var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_40047",
    "data-name": "Group 40047",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40044",
    "data-name": "Group 40044",
    transform: "translate(7.38 3.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40043",
    "data-name": "Group 40043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143439",
    "data-name": "Path 143439",
    d: "M239.639,124.48l-2.231-1.673V119.4a.62.62,0,0,0-1.239,0v3.718a.618.618,0,0,0,.248.5l2.479,1.859a.62.62,0,0,0,.744-.992Z",
    transform: "translate(-236.169 -118.779)",
    fill: "#76747f"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40046",
    "data-name": "Group 40046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40045",
    "data-name": "Group 40045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143440",
    "data-name": "Path 143440",
    d: "M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0ZM8,14.761A6.761,6.761,0,1,1,14.761,8,6.769,6.769,0,0,1,8,14.761Z",
    fill: "#76747f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.63fb6413a31264c5496aa53c722c5751.svg";
export { ForwardRef as ReactComponent };